module.exports = __webpack_public_path__ + "static/media/creditcard-avant.a4754501.png";